const KEYS = {
    PROFILE: 'hl_profile',
    DAILY_LOGS: 'hl_daily_logs',
    PRODUCT_EVENTS: 'hl_product_events',
    SCORES: 'hl_scores',
    PENDING_PRODUCTS: 'hl_pending_products',
};

export function getProfile() {
    const raw = localStorage.getItem(KEYS.PROFILE);
    if (!raw) return null;
    const profile = JSON.parse(raw);

    const goal = profile.goal || 'balanced';
    profile.goalMultipliers = {
        metabolic: goal === 'metabolic' ? 1.5 : 1.0,
        stress: goal === 'stress' ? 1.5 : 1.0,
        reproductive: (goal === 'fertility' ? 1.5 : 1.0) * (profile.ttc ? 1.4 : 1.0),
        thyroid: goal === 'thyroid' ? 1.5 : 1.0,
        skin: (goal === 'skin' ? 1.5 : 1.0) * (profile.acneProne ? 1.3 : 1.0),
    };

    return profile;
}

export function saveProfile(profile) {
    localStorage.setItem(KEYS.PROFILE, JSON.stringify(profile));
}

export function getDailyLog(date) {
    const logs = getAllDailyLogs();
    return logs[date] || null;
}

export function saveDailyLog(date, log) {
    const logs = getAllDailyLogs();
    logs[date] = { ...log, updatedAt: new Date().toISOString() };
    localStorage.setItem(KEYS.DAILY_LOGS, JSON.stringify(logs));
}

export function getAllDailyLogs() {
    const raw = localStorage.getItem(KEYS.DAILY_LOGS);
    return raw ? JSON.parse(raw) : {};
}

export function getProductEvents(date) {
    const all = getAllProductEvents();
    return all[date] || [];
}

export function addProductEvent(date, event) {
    const all = getAllProductEvents();
    if (!all[date]) all[date] = [];
    all[date].push({ ...event, addedAt: new Date().toISOString() });
    localStorage.setItem(KEYS.PRODUCT_EVENTS, JSON.stringify(all));
}

export function removeProductEvent(date, index) {
    const all = getAllProductEvents();
    if (all[date]) {
        all[date].splice(index, 1);
        localStorage.setItem(KEYS.PRODUCT_EVENTS, JSON.stringify(all));
    }
}

export function getAllProductEvents() {
    const raw = localStorage.getItem(KEYS.PRODUCT_EVENTS);
    return raw ? JSON.parse(raw) : {};
}

export function saveScores(date, scores) {
    const all = getAllScores();
    all[date] = scores;
    localStorage.setItem(KEYS.SCORES, JSON.stringify(all));
}

export function getScores(date) {
    const all = getAllScores();
    return all[date] || null;
}

export function getAllScores() {
    const raw = localStorage.getItem(KEYS.SCORES);
    return raw ? JSON.parse(raw) : {};
}

// ===== Pending Products (user-submitted when OFF/OBF miss) =====

export function getPendingProducts() {
    const raw = localStorage.getItem(KEYS.PENDING_PRODUCTS);
    return raw ? JSON.parse(raw) : [];
}

export function getPendingProduct(barcode) {
    return getPendingProducts().find(p => p.barcode === barcode) || null;
}

export function savePendingProduct(product) {
    const all = getPendingProducts();
    const existing = all.findIndex(p => p.barcode === product.barcode);
    const entry = {
        ...product,
        source: 'user',
        id: `user-${product.barcode || Date.now()}`,
        submittedAt: new Date().toISOString(),
    };
    if (existing >= 0) {
        all[existing] = entry;
    } else {
        all.push(entry);
    }
    localStorage.setItem(KEYS.PENDING_PRODUCTS, JSON.stringify(all));
    return entry;
}

export function removePendingProduct(barcode) {
    const all = getPendingProducts().filter(p => p.barcode !== barcode);
    localStorage.setItem(KEYS.PENDING_PRODUCTS, JSON.stringify(all));
}
